import { Modal } from 'antd';
import { useState, useEffect } from 'react';
import styles from './MobileDeviceModal.module.scss';

const isMobileDevice = () => {
  return /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

const MobileDeviceModal = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isAuthRoute = window.location.pathname.startsWith('/auth');
    if (isMobileDevice() && !isAuthRoute) {
      setVisible(true);
    }
  }, []);

  return (
    <Modal
      open={visible}
      footer={null}
      centered
      closable={true}
      maskClosable={true}
      onCancel={() => setVisible(false)}
      className={styles.mobileModal}
      rootClassName="blurred-backdrop-modal"
    >
      <div className={styles.content}>
        <h2 className={styles.title}>Desktop Recommended</h2>
        <p className={styles.message}>
          This app is not optimized for mobile devices. For the best experience,
          please visit on a desktop or laptop computer.
        </p>
      </div>
    </Modal>
  );
};

export default MobileDeviceModal;
